import { Box } from "@mui/material";
import { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ScreenOverlay from "../screenOverlay/ScreenOverlay";

import TopNavigationBar from "../topNavigationBar/TopNavigationBar";

const AppContent: React.FC = () => {
  const [overlayVisible, setOverlayVisible] = useState<boolean>(false);
  const [subOverlay, setSubOverlay] = useState<string | null>(null);
  const [isHamburgerClosed, setHamburgerClosed] = useState<boolean>(true);

  const location = useLocation();
  const navigate = useNavigate();

  // Check if we're on the portfolio page
  const isPortfolioPage = location.pathname === '/portfolio';

  const toggleScreenOverlay = () => {
    setOverlayVisible(!overlayVisible);
    setHamburgerClosed(!isHamburgerClosed);
  };

  const overlayItemSelected = () => {
    toggleScreenOverlay();
    setHamburgerClosed(true);
  };

  const subOverlayItemSelected = () => {
    overlayItemSelected();
    setSubOverlay(null);
  };

  const inRootPath = (): boolean => ["", "/", "/home"].includes(location.pathname);

  const renderContent = () =>
    overlayVisible ? (
      <ScreenOverlay
        onItemSelect={overlayItemSelected}
        onSubItemSelect={subOverlayItemSelected}
        subOverlay={subOverlay}
        setSubOverlay={setSubOverlay}
      />
    ) : (
      <Outlet
        style={{
          paddingTop: "60px",
          overflowY: "scroll",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      ></Outlet>
    );

  return (
    <Box
      sx={{
        width: "100%",
        // overflow: "hidden",
      }}
    >
      {/* Conditionally render navigation bar - hide on portfolio page */}
      {!isPortfolioPage && (
        <TopNavigationBar
          onHamburgerClick={toggleScreenOverlay}
          isHamburgerClosed={isHamburgerClosed}
          backArrowVisible={subOverlay || !inRootPath()}
          goBackCallback={() =>
            subOverlay ? setSubOverlay(null) : navigate("/")
          }
        ></TopNavigationBar>
      )}
      <Box
        display={"flex"}
        minHeight="80%"
        justifyContent={"center"}
        alignItems={"center"}
        className="contentHolder"
        sx={{
          paddingTop: isPortfolioPage ? 0 : undefined,
        }}
      >
        {renderContent()}
      </Box>
    </Box>
  );
};

export default AppContent;
